import Cookies from "universal-cookie";
import axiosInstance from "../../../core/api/axios";
import { LOCAL_STORAGE_KEY_ACCESS_TOKEN, setLocalStorage } from '../../../core/commom/localStorage';
import env from "../../../core/env";
import TrackEventsUser from '../../../core/track/trackEventsUser';
import { ILoginCredentials, IRegister, LoginResponse } from "../models/user.model";
import { useFreeHistoryStore } from "../../../core/stores/freeHistoryStore";

export async function login(credentials: ILoginCredentials): Promise<LoginResponse> {
  const response =  await axiosInstance.post('/auth/login', {
    ...credentials,
    application: 'web',
  })

  if(response.data && response.data.access_token) {
    const token_key = env.REACT_APP_COOKIE_NAME;

    const cookies = new Cookies(null, { path: '/', domain: env.REACT_APP_COOKIE_DOMAIN })
    cookies.set(token_key, response.data.access_token);

    setLocalStorage(LOCAL_STORAGE_KEY_ACCESS_TOKEN, response.data.access_token);

    TrackEventsUser("LOGIN_SUCCESS", "v2")
  }

  return response.data
}

export async function requestMe(): Promise<any> {
    const setViewedContent = useFreeHistoryStore.getState().setViewedContent;
    
    const response =  await axiosInstance.post('/auth/me')

    const token_key = env.REACT_APP_COOKIE_NAME;
    const cookies = new Cookies(null, { path: '/', domain: env.REACT_APP_COOKIE_DOMAIN });
    cookies.set(token_key, response.data.access_token)

    if(response.data.permissions.modulesGranted.includes('universitario-navegacao-livre-free')) {
      const { data } = await axiosInstance.get('/universitario/history')

      setViewedContent(data.viewedContent)
    }

    return response.data
}
interface IRequestCodeForgotPassword {
    email: string;
}

export async function requestCodeForgotPassword(body: IRequestCodeForgotPassword): Promise<any> {
    const response =  await axiosInstance.post('/password/forgout', body)
    return response.data
}

interface IRequestValidaCodeForgotPassword {
    email: string;
    code: string
}

export async function requestValidCodeForgotPassword(body: IRequestValidaCodeForgotPassword): Promise<any> {
    const response =  await axiosInstance.post('/password', body)
    return response.data
}

interface IRequestForgotPassword {
    code: string
    password: string
    email: string
}

export async function requestForgotPassword(body: IRequestForgotPassword): Promise<any> {
    const response =  await axiosInstance.put('/password', body)
    return response.data
}

export async function requestCreatePassword(token: string, password: string) {
    try {
        const { data } = await axiosInstance.post(`/user/create-pwd`, { token, password });

        return data;
    } catch(e: any) {
        throw new Error(e);
    }
}

export async function createFreeUser(body: IRegister): Promise<any> {
  try {
    const response =  await axiosInstance.post('/user', body)
    
    return response.data
  } catch(e: any) {
    console.log(e)
    throw new Error(e);
  }
}
